import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-tracker" }
const _hoisted_2 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompanySearch = _resolveComponent("CompanySearch")
  const _component_TrackerSegment = _resolveComponent("TrackerSegment")
  const _component_TrackerButtongroup = _resolveComponent("TrackerButtongroup")
  const _component_TrackerSlider = _resolveComponent("TrackerSlider")
  const _component_TrackerTextarea = _resolveComponent("TrackerTextarea")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, " Track Company ", -1 /* HOISTED */)),
    _createVNode(_component_ScrollBar, {
      class: "settings",
      "bar-x-offset": "-2rem"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TrackerSegment, {
          title: "LinkedIn",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompanySearch, {
              ref: "linkedin",
              modelValue: $data.company,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.company) = $event)),
              "hide-followed": "",
              required: "",
              placeholder: "e.g. acme"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_TrackerSegment, {
          title: "Relationship",
          tooltip: "relationship"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrackerButtongroup, {
              modelValue: $data.tracker_type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.tracker_type) = $event)),
              options: $data.TYPES,
              class: "button-group"
            }, null, 8 /* PROPS */, ["modelValue", "options"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_TrackerSegment, {
          title: "TRACKER SENSITIVITY",
          tooltip: "signal_sensitivity"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrackerSlider, {
              modelValue: $options.slider_focus,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.slider_focus) = $event)),
              class: "slider",
              step: 50,
              "show-tooltip": false,
              greyed: $options.focus_text
            }, null, 8 /* PROPS */, ["modelValue", "greyed"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_TrackerSegment, {
          title: "Email Alerts",
          tooltip: "email_notifications",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrackerButtongroup, {
              modelValue: $data.tracker_alerts,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.tracker_alerts) = $event)),
              options: $data.ALERTS,
              class: "button-group"
            }, null, 8 /* PROPS */, ["modelValue", "options"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_TrackerSegment, {
          title: "WHAT SHOULD WE WATCH FOR?",
          tooltip: "company_customize_tracking"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrackerTextarea, {
              modelValue: $data.focus_on,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.focus_on) = $event)),
              title: "Focus tracking on:",
              placeholder: "e.g. product launches, partnerships, executive changes",
              class: "textarea"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_Divider, { m: "0 -2.4rem 2.4rem" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        class: "delete-button",
        disabled: $data.saving,
        onClick: _cache[5] || (_cache[5] = $event => (_ctx.$dispatch('cancel')))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_Button, {
        primary: "",
        loading: $data.saving,
        disabled: !$options.can_save,
        onClick: $options.onSave
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("Start tracking")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["loading", "disabled", "onClick"])
    ])
  ]))
}